import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'

import Welcome from '../views/Welcome.vue'

// 账号管理
import Account from '../views/account/Account.vue'
import AddAccount from '../views/account/AddAccount.vue'
import ModifyAccount from '../views/account/ModifyAccount.vue'

// 角色管理
import Role from '../views/role/Role.vue'
import AddRole from '../views/role/AddRole.vue'
import ModifyRole from '../views/role/ModifyRole.vue'

// 系统管理-员工管理（全局）
import SystemEmployeeList from '../views/system/EmployeeList.vue'
import SystemEmployeeAdd from '../views/system/EmployeeAdd.vue'
import SystemEmployeeModify from '../views/system/EmployeeModify.vue'

// 系统日志
import Log from '../views/log/Log.vue'

// 数据管理
import Import from '../views/data/Import.vue'

// 堆雪球管理
import DuixueqiuToken from '../views/duixueqiu/Token.vue'
import DuixueqiuApiTest from '../views/duixueqiu/ApiTest.vue'
import DuixueqiuWeixinList from '../views/duixueqiu/WeixinList.vue'
import DuixueqiuFriendList from '../views/duixueqiu/FriendList.vue'

// 财务管理
import FinanceLoginSession from '../views/finance/LoginSession.vue'
import FinanceStoreMapping from '../views/finance/StoreMapping.vue'
import FinanceOrderData from '../views/finance/OrderData.vue'
import FinanceOrderDetail from '../views/finance/OrderDetail.vue'
import FinanceZhaoshangData from '../views/finance/ZhaoshangData.vue' // 招商数据（静态演示阶段）
import FinanceYunyingData from '../views/finance/YunyingData.vue' // 运营数据（静态演示阶段）

// 人事管理
import RenshiCheckinData from '../views/renshi/CheckinData.vue'
import RenshiCheckinConfig from '../views/renshi/CheckinConfig.vue'
import RenshiContacts from '../views/renshi/Contacts.vue'
import RenshiNotify from '../views/renshi/Notify.vue'

// 招商部
import ZhaoshangRenyuanList from '../views/zhaoshang/RenyuanList.vue'
import ZhaoshangRenyuanAdd from '../views/zhaoshang/RenyuanAdd.vue'
import ZhaoshangRenyuanModify from '../views/zhaoshang/RenyuanModify.vue'

// 任务管理
import ZhaoshangRenwuList from '../views/zhaoshang/RenwuList.vue'
import ZhaoshangCustomerList from '../views/zhaoshang/CustomerList.vue'
import ZhaoshangCustomerAdd from '../views/zhaoshang/CustomerAdd.vue'
import ZhaoshangCustomerModify from '../views/zhaoshang/CustomerModify.vue'

import ZhaoshangProjectAdd from '../views/zhaoshang/ProjectAdd.vue'
import ZhaoshangProjectModify from '../views/zhaoshang/ProjectModify.vue'

import ZhaoshangBillAddIncome from '../views/zhaoshang/BillAddIncome.vue' // 新增收款(尾款)
import ZhaoshangBillAddReIncome from '../views/zhaoshang/BillAddReIncome.vue' // 新增收款(客户续签)
import ZhaoshangBillAddRefund from '../views/zhaoshang/BillAddRefund.vue' // 新增退款(解约)
import ZhaoshangContractModify from '../views/zhaoshang/ContractModify.vue' // 修改合同
import ZhaoshangBillModifyIncome from '../views/zhaoshang/BillModifyIncome.vue' // 修改收款
import ZhaoshangBillModifyRefund from '../views/zhaoshang/BillModifyRefund.vue' // 修改退款

import ZhaoshangZhuanyuanWorkbench from '../views/zhaoshang/workbench/Zhuanyuan.vue'
import ZhaoshangZhuguanWorkbench from '../views/zhaoshang/workbench/Zhuguan.vue'
import ZhaoshangZongjianWorkbench from '../views/zhaoshang/workbench/Zongjian.vue'

import ZhaoshangMap from '../views/zhaoshang/Map.vue'
import ZhaoshangWorkTransfer from '../views/zhaoshang/WorkTransfer.vue' // 招商工作移交
import ZhaoshangRecycleBin from '../views/zhaoshang/RecycleBin.vue' // 回收站
import ZhaoshangProjectTransfer from '../views/zhaoshang/TransferMock.vue' // 项目转让
import ZhaoshangProjectGroup from '../views/zhaoshang/ProjectGroup.vue' // 项目群管理
import ZhaoshangChatList from '../views/zhaoshang/ChatList.vue' // 客户沟通列表
import ZhaoshangChatDetail from '../views/zhaoshang/ChatDetail.vue' // 客户沟通聊天记录
// import ZhaoshangMigrate from '../views/zhaoshang/MigrateContract.vue'

// 运营部
import YunweiWework from '../views/yunwei/Wework.vue'
import YunweiWeworkPushMonitor from '../views/yunwei/WeworkPushMonitor.vue'
import YunweiWaimai from '../views/yunwei/Waimai.vue'
import YunweiYunyingData from '../views/yunwei/YunyingData.vue'
import YunweiCommentData from '../views/yunwei/CommentData.vue'
import DataMonitor from '../views/yunwei/DataMonitor.vue'
import ScheduleManage from '../views/yunwei/Schedule.vue'
import ScmCollectLog from '../views/yunwei/ScmCollectLog.vue'
import ScmDataMonitor from '../views/yunwei/ScmDataMonitor.vue'
import ImAutoReply from '../views/yunwei/ImAutoReply.vue'
import CommentTemplate from '../views/yunwei/CommentTemplate.vue'
import CollectorManage from '../views/yunwei/Collector.vue'
import BrandManage from '../views/yunwei/Brand.vue'
import YunyingData from '../views/yunying/Data.vue'
import YunyingDataManage from '../views/yunying/DataManage.vue'
import YunyingDianpu from '../views/yunying/Dianpu.vue'
import Kaiye from '../views/yunying/Kaiye.vue'
import YunyingChoujianList from '../views/yunying/ChoujianList.vue' // 运营管理-筹建列表
import YunyingChoujianDetail from '../views/yunying/ChoujianDetail.vue' // 运营管理-筹建详情（只读）

import YunyingRenyuanList from '../views/yunying/RenyuanList.vue'
import YunyingRenyuanAdd from '../views/yunying/RenyuanAdd.vue'
import YunyingRenyuanModify from '../views/yunying/RenyuanModify.vue'

import YunyingWorkTransfer from '../views/yunying/WorkTransfer.vue' // 运营工作移交
import YunyingProxyManage from '../views/yunying/ProxyManage.vue' // 代运营管理
import YunyingDailyReport from '../views/yunying/DailyReport.vue' // 日报管理
import YunyingNegativeCommentReport from '../views/yunying/NegativeCommentReport.vue' // 差评日报管理
import YunyingPushConfig from '../views/yunying/PushConfig.vue' // 推送管理
import PatrolMonitor from '../views/yunying/PatrolMonitor.vue' // 巡店异常监控

// 督导部
import ChoujianDetail from '../views/dudao/ChoujianDetail.vue'
import ChoujianWorkbench from '../views/dudao/ChoujianWorkbench.vue'
import ChoujianManage from '../views/dudao/ChoujianManage.vue'
import Peixun from '../views/dudao/Peixun.vue'
import Sheji from '../views/dudao/Sheji.vue' // 设计师工作台
import Jiandian from '../views/dudao/Jiandian.vue'
import DudaoYunying from '../views/dudao/Yunying.vue'

import DudaoRenyuanList from '../views/dudao/RenyuanList.vue'
import DudaoRenyuanAdd from '../views/dudao/RenyuanAdd.vue'
import DudaoRenyuanModify from '../views/dudao/RenyuanModify.vue'

import DudaoZhuguan from '../views/dudao/Zhuguan.vue'
import DudaoWorkTransfer from '../views/dudao/WorkTransfer.vue' // 督导工作移交
import SupervisorRegion from '../views/dudao/SupervisorRegion.vue'
import ChupinShenhe from '../views/dudao/ChupinShenhe.vue' // 出品审核工作台

// 题库管理
import CategoryList from '../views/tiku/CategoryList.vue'
import QuestionList from '../views/tiku/QuestionList.vue'
import ExamList from '../views/tiku/ExamList.vue'
import RecordList from '../views/tiku/RecordList.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },

  {
    path: '/home',
    component: Home,
    redirect: '/welcome',
    children: [
      { path: '/welcome', component: Welcome },

      // 账号管理
      { path: '/account', component: Account },
      { path: '/account/add', component: AddAccount },
      { path: '/account/modify/:id', component: ModifyAccount },

      // 角色管理
      { path: '/role', component: Role },
      { path: '/role/add', component: AddRole },
      { path: '/role/modify/:id', component: ModifyRole },

      // 系统管理-员工管理（全局）
      { path: '/system/employee', component: SystemEmployeeList },
      { path: '/system/employee/add', component: SystemEmployeeAdd },
      { path: '/system/employee/modify/:id', component: SystemEmployeeModify },
      { path: '/role/assistant/:id', component: () => import('@/views/role/AssistantConfig.vue') },

      { path: '/log', component: Log },
      { path: '/import', component: Import },

      // 堆雪球管理
      { path: '/duixueqiu/token', component: DuixueqiuToken },
      { path: '/duixueqiu/api', component: DuixueqiuApiTest },
      { path: '/duixueqiu/weixinList', component: DuixueqiuWeixinList },
      { path: '/duixueqiu/friendList', component: DuixueqiuFriendList },

      // 财务管理
      { path: '/finance/loginSession', component: FinanceLoginSession },
      { path: '/finance/storeMapping', component: FinanceStoreMapping },
      { path: '/finance/orderData', component: FinanceOrderData },
      { path: '/finance/orderDetail', component: FinanceOrderDetail },
      { path: '/finance/zhaoshangData', component: FinanceZhaoshangData },
      { path: '/finance/yunyingData', component: FinanceYunyingData },

      // 人事管理
      { path: '/renshi/checkin', component: RenshiCheckinData },
      { path: '/renshi/checkinConfig', component: RenshiCheckinConfig },
      { path: '/renshi/contacts', component: RenshiContacts },
      { path: '/renshi/notify', component: RenshiNotify },

      // 招商部
      { path: '/zhaoshang/renyuan', component: ZhaoshangRenyuanList },
      { path: '/zhaoshang/renyuan/add', component: ZhaoshangRenyuanAdd },
      { path: '/zhaoshang/renyuan/modify/:id', component: ZhaoshangRenyuanModify },

      // 任务管理
      { path: '/zhaoshang/renwu', component: ZhaoshangRenwuList },
      { path: '/zhaoshang/customer', component: ZhaoshangCustomerList },
      { path: '/zhaoshang/customer/add', component: ZhaoshangCustomerAdd },
      { path: '/zhaoshang/customer/modify/:id', component: ZhaoshangCustomerModify },

      // 项目管理
      { path: '/zhaoshang/project/add', component: ZhaoshangProjectAdd },
      { path: '/zhaoshang/project/modify/:id', component: ZhaoshangProjectModify },

      // 合同管理
      { path: '/zhaoshang/contract/modify/:id', component: ZhaoshangContractModify },

      // 财务记录管理
      { path: '/zhaoshang/financial/addIncome', component: ZhaoshangBillAddIncome },
      { path: '/zhaoshang/financial/addReIncome', component: ZhaoshangBillAddReIncome },
      { path: '/zhaoshang/financial/addRefund', component: ZhaoshangBillAddRefund },
      { path: '/zhaoshang/financial/modifyIncome/:id', component: ZhaoshangBillModifyIncome },
      { path: '/zhaoshang/financial/modifyRefund/:id', component: ZhaoshangBillModifyRefund },

      // 招商部门工作台
      { path: '/zhaoshang/zhuanyuan', component: ZhaoshangZhuanyuanWorkbench },
      { path: '/zhaoshang/zhuguan', component: ZhaoshangZhuguanWorkbench },
      { path: '/zhaoshang/zongjian', component: ZhaoshangZongjianWorkbench },

      // 门店地图
      { path: '/zhaoshang/map', component: ZhaoshangMap },

      // 招商工作移交
      { path: '/zhaoshang/workTransfer', component: ZhaoshangWorkTransfer },
      { path: '/zhaoshang/projectGroup', component: ZhaoshangProjectGroup },

      // 回收站
      { path: '/zhaoshang/recycleBin', component: ZhaoshangRecycleBin },

      // 项目转让
      { path: '/zhaoshang/project/transfer', component: ZhaoshangProjectTransfer },

      // 客户沟通分析（一期）
      { path: '/zhaoshang/chat', component: ZhaoshangChatList },
      { path: '/zhaoshang/chat-detail', component: ZhaoshangChatDetail },

      // 合同数据迁移（管理员专用）
      // { path: '/zhaoshang/migrate', component: ZhaoshangMigrate },

      // 运营部
      { path: '/yunwei/wework', component: YunweiWework },
      { path: '/yunwei/weworkPushMonitor', component: YunweiWeworkPushMonitor },
      { path: '/yunwei/waimai', component: YunweiWaimai },
      { path: '/yunwei/yunyingData', component: YunweiYunyingData },
      { path: '/yunwei/commentData', component: YunweiCommentData },
      { path: '/yunwei/dataMonitor', component: DataMonitor },
      { path: '/yunwei/schedule', component: ScheduleManage },
      { path: '/yunwei/scmCollectLog', component: ScmCollectLog },
      { path: '/yunwei/scmDataMonitor', component: ScmDataMonitor },
      { path: '/yunwei/imAutoReply', component: ImAutoReply },
      { path: '/yunwei/commentTemplate', component: CommentTemplate },
      { path: '/yunwei/collector', component: CollectorManage },
      { path: '/yunwei/brand', component: BrandManage },
      { path: '/yunying/data', component: YunyingData },
      { path: '/yunying/dataManage', component: YunyingDataManage },
      { path: '/yunying/dianpu', component: YunyingDianpu },
      { path: '/yunying/kaiye', component: Kaiye },
      { path: '/yunying/choujian', component: YunyingChoujianList },
      { path: '/yunying/choujian/detail/:instanceId', component: YunyingChoujianDetail },
      { path: '/yunying/dailyReport', component: YunyingDailyReport },
      { path: '/yunying/negativeCommentReport', component: YunyingNegativeCommentReport },
      { path: '/yunying/pushConfig', component: YunyingPushConfig },

      { path: '/yunying/renyuan', component: YunyingRenyuanList },
      { path: '/yunying/renyuan/add', component: YunyingRenyuanAdd },
      { path: '/yunying/renyuan/modify/:id', component: YunyingRenyuanModify },

      // 运营工作移交
      { path: '/yunying/workTransfer', component: YunyingWorkTransfer },

      // 代运营管理
      { path: '/yunying/proxy', component: YunyingProxyManage },

      // 巡店异常监控
      { path: '/yunying/patrolMonitor', component: PatrolMonitor },

      // 督导部
      { path: '/dudao/choujian', component: ChoujianWorkbench },
      { path: '/dudao/choujian/detail/:instanceId', component: ChoujianDetail },
      { path: '/dudao/choujianManage', component: ChoujianManage },
      { path: '/dudao/peixun', component: Peixun },
      { path: '/dudao/sheji', component: Sheji }, // 设计师工作台
      { path: '/dudao/jiandian', component: Jiandian },
      { path: '/dudao/yunying', component: DudaoYunying },

      { path: '/dudao/renyuan', component: DudaoRenyuanList },
      { path: '/dudao/renyuan/add', component: DudaoRenyuanAdd },
      { path: '/dudao/renyuan/modify/:id', component: DudaoRenyuanModify },

      { path: '/dudao/zhuguan', component: DudaoZhuguan },
      { path: '/dudao/workTransfer', component: DudaoWorkTransfer },
      { path: '/dudao/supervisorRegion', component: SupervisorRegion },
      { path: '/dudao/chupinShenhe', component: ChupinShenhe }, // 出品审核工作台

      // 题库管理
      { path: '/tiku/category', component: CategoryList, meta: { title: '分类管理' } },
      { path: '/tiku/question', component: QuestionList, meta: { title: '题目管理' } },
      { path: '/tiku/exam', component: ExamList, meta: { title: '测试管理' } },
      { path: '/tiku/record', component: RecordList, meta: { title: '答题结果' } },

      // 智能助手（独立会话页；全局抽屉挂在 App.vue，不依赖菜单）
      { path: '/assistant', component: () => import('@/views/assistant/Index.vue'), meta: { title: '智能助手' } },
      { path: '/assistant/downloads', component: () => import('@/views/assistant/Downloads.vue'), meta: { title: '下载中心' } },
      // 管理面（P1.5 菜单组入口：运营观测/技能治理/知识条目）
      { path: '/assistant/admin', component: () => import('@/views/assistant/Admin.vue'), meta: { title: '运营观测' } },
      { path: '/assistant/admin/skills', component: () => import('@/views/assistant/Skills.vue'), meta: { title: '技能治理' } },
      { path: '/assistant/admin/knowledge', component: () => import('@/views/assistant/Knowledge.vue'), meta: { title: '知识条目' } },

      // 绩效管理
      { path: '/performance/rules', component: () => import('@/views/performance/rules.vue'), meta: { title: '绩效规则管理' } },
      { path: '/performance/employee-groups', component: () => import('@/views/performance/employeeGroups.vue'), meta: { title: '员工绩效分组' } },

      // 全局概览
      { path: '/overview/operation', component: () => import('@/views/overview/OperationOverview.vue'), meta: { title: '运营概览' } }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
